/* eslint-disable no-use-before-define */
import React from 'react'
import { Disclosures, yieldGridLastUpdated } from '../../twd'

export default () => {
    let s = yieldGridLastUpdated()
    return <div className="row">
    <div className="col-xs-12 col-md-8">
    {s ? s + ' \u00A0 | \u00A0 ': ''}
    Yields update as prices change, and may be delayed.  Please see disclosures.
    </div>
    <div className="col-xs-12 col-md-4 text-right">
        <Disclosures
            dataName='corporates-yield-grid-disclosures-link'
            html={DISCLOSURES}
        />
    </div>
    </div>
}

let DISCLOSURES = `
    <p>
    The Yield by Category table can be sorted by highest or average yield.
    By default, the table is configured to display the highest available yield on
    the Tradeweb dealer network aligned with each asset class and maturity.
    To view the average yield amongst available offers for a given asset class and maturity,
    simply click the "Average Yield" toggle above the table.
    </p>
    <p>
    The yield values displayed represent the existence of a minimum of 10 bonds ($1,000 face value)
    available at the respective credit ratings (as designated by Moody's or S&P) for which the ask price
    is between 85 and 120, excluding zero-coupon bonds (US Treasury Zeroes).
    </p>
    <p>
    Yields displayed within the grid will update in response to changes in available offerings and offering prices.
    These yields will update as offer pricing changes throughout the trading day and may be delayed.
    </p>`
